export const STRIPE_CURRENCY_OPTIONS = [
  "usd", "eur", "gbp", "cad", "aud", "jpy", "chf", "sgd", "nzd", "hkd",
  "aed", "sar", "sek", "nok", "dkk", "pln", "czk", "zar", "brl", "mxn",
].map((value) => ({ value, label: value.toUpperCase() }));

export const TAX_CALCULATION_OPTIONS = [
  { value: "inclusive", label: "Tax inclusive" },
  { value: "exclusive", label: "Tax exclusive" },
];
